
import React from 'react';
import { ColorPicker } from "./CSSEditor/colorPicker";
import { sprintf } from 'sprintf-js';

const labels = {
  stocks: "Stocks",
  bonds: "Bonds",
  alt: "Alternative",
  cash: "Cash",
};

class ChartColors extends React.Component {

  constructor(props) {
    super(props);

    if (props.css.chart_colors) {
      this.state = props.css.chart_colors;
    } else {
      this.state = {
        stocks: { r: 0, g: 0, b: 0},
        bonds: { r: 0, g: 0, b: 0},
        alt: { r: 0, g: 0, b: 0},
        cash: { r: 0, g: 0, b: 0},
      };
    }
  }

  getColor = id => {
    return this.state[id];
  };

  onChange = (color, id) => {
    this.setState({
      [id]: color,
    }, () => {
      this.props.onChange(this.state);
    })
  };

  renderColor = id => {
    const label = sprintf("%s Palette", labels[id]);
    return (
      <div>
        <span>{label}</span>
        <ColorPicker
          type={id}
          getColour={this.getColor}
          onChange={this.onChange}/>
      </div>
    );
  };

  render = () => {

    const ids = [ "stocks", "bonds", "alt", "cash"];
    const columns = ids.map(id => {
      return (
        <div className="column is-3" key={id}>
          { this.renderColor(id) }
        </div>
      )
    });

    return (
      <div className="columns">
        { columns }
      </div>
    )
  }
}

export { ChartColors };
